<div class="info-popover">
    <span class="NeueClose" title="Close info" (click)="close()"></span>
    <ul id="hash-tag-info-list-cont" >
        <li>Tags can be Alpha numeric, no special character allowed.</li>
        <li>Tags CAN'T be numbers only. For example #1234 is not allowed.</li>
        <li>Tags CAN'T start with numbers. </li>
        <li>Minimum length of tag is 3 character, max 30 character.</li>
        <li>Max 10 tags can be added on any file.</li>
        <li>Tags storage and displays is case sensitive but search is NOT.</li>
        <li>MumbaiIndian and mumbaiindian are different tags but both will appear in search as search is case insensitive.</li>
    </ul>
</div>